import React, { createContext, useContext } from 'react';
import { useToggleBiometrics } from '../../hooks/useToggleBiometrics';

const BiometricsContext = createContext<
  ReturnType<typeof useToggleBiometrics> | undefined
>(undefined);

export const BiometricsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const biometrics = useToggleBiometrics();

  return (
    <BiometricsContext.Provider value={biometrics}>
      {children}
    </BiometricsContext.Provider>
  );
};

export const useBiometrics = () => {
  const ctx = useContext(BiometricsContext);

  if (!ctx) {
    throw new Error('useBiometrics must be used within BiometricsProvider');
  }

  return ctx;
};
